var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { Tool } from '../../../model/tool/Tool';
let ToolComponent = class ToolComponent extends LitElement {
    constructor() {
        super(...arguments);
        this.size = 'small';
    }
    connectedCallback() {
        super.connectedCallback();
        this.tabIndex = 0;
        this.setAttribute('role', 'button');
        this.setAttribute('aria-label', this.tool?.name ?? 'tool');
    }
    onClick() {
        if (this.toolBox)
            if (this.tool?.execute) {
                this.tool.execute(this.map.getMapInstance(), this.map.getMapLib(), this.toolBox);
            }
    }
    onKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.onClick();
        }
    }
    render() {
        return html `
      <div class="tool" @click=${this.onClick} @keydown=${this.onKeyDown}>
        <div class="icon">
          ${this.tool?.icon
            ? html `<img src="${this.tool.icon}" alt="${this.tool.name}" />`
            : html `<span>?</span>`}
        </div>
      </div>
    `;
    }
};
ToolComponent.styles = css `
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      outline: none;
      user-select: none;
    }

    /* --- TOOL WRAPPER --- */
    .tool {
      display: grid;
      place-items: center; /* pour centrer le container */
      border-radius: 50%;
      background: var(--tool-bg, #f0f0f0);
      width: var(--tool-size);
      height: var(--tool-size);
      transition: transform 0.15s ease;
    }

    /* --- ICON --- */
    .icon {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .icon img {
      width: 70%;
      height: 70%;
      object-fit: contain;
      display: block;
    }

    :host(:hover) .tool,
    :host(:focus-visible) .tool {
      transform: scale(1.07);
      background: var(--tool-bg-hover, #e5e5e5);
    }

    /* --- SIZE VARIANTS --- */
    :host([size='small']) {
      --tool-size: 24px;
    }

    :host([size='large']) {
      --tool-size: 48px;
    }

    /* --- NAME TOOLTIP --- */
    .name {
      position: absolute;
      bottom: calc(-1.8rem);
      left: 50%;
      transform: translateX(-50%) translateY(4px);
      background: rgba(255, 255, 255, 0.97);
      padding: 3px 8px;
      border-radius: 6px;
      color: #333;
      font-size: 12px;
      font-weight: 500;
      opacity: 0;
      pointer-events: none;
      transition:
        opacity 0.25s ease,
        transform 0.25s ease;
      white-space: nowrap;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
    }

    :host(:hover) .name,
    :host(:focus-visible) .name {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  `;
__decorate([
    property({ type: Object })
], ToolComponent.prototype, "tool", void 0);
__decorate([
    property({ type: Object })
], ToolComponent.prototype, "map", void 0);
__decorate([
    property({ type: Object })
], ToolComponent.prototype, "toolBox", void 0);
__decorate([
    property({ type: String })
], ToolComponent.prototype, "size", void 0);
ToolComponent = __decorate([
    customElement('map-tool')
], ToolComponent);
export { ToolComponent };
//# sourceMappingURL=ToolComponent.js.map